import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
  Divider,
} from "@mui/material";

interface HelpDialogProps {
  open: boolean;
  onClose: () => void;
}

export default function HelpDialog({ open, onClose }: HelpDialogProps) {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>💣 Random Bomb 사용 방법</DialogTitle>

      <DialogContent dividers>
        <Stack spacing={2}>
          <Typography fontWeight={600}>
            🎮 Random Bomb는 순서를 정해 놀 때 긴장감을 주는 게임입니다.
          </Typography>

          <Typography>
            예를 들어 <b>시작</b> 버튼을 누른 뒤, 친구들과 번갈아 가며
            끝말잇기를 합니다.
          </Typography>

          <Typography>
            어느 순간 갑자기 알람이 울리면, 그때 말하고 있던 사람이
            <b> 당첨(벌칙 대상)</b>입니다 💥
          </Typography>

          <Divider />

          <Typography fontWeight={600}>📌 활용 예시</Typography>
          <Typography>- 끝말잇기</Typography>
          <Typography>- 진실게임</Typography>
          <Typography>- 질문 릴레이</Typography>
          <Typography>- 술게임 순서 정하기</Typography>
          <Typography>- 발표자 랜덤 선정</Typography>

          <Divider />

          <Typography fontWeight={600}>🕒 플레이 방법</Typography>
          <Typography>1. 분 또는 초로 시간을 설정합니다.</Typography>
          <Typography>2. 시작 버튼을 누릅니다.</Typography>
          <Typography>3. 자유롭게 게임을 진행합니다.</Typography>
          <Typography>4. 랜덤한 시점에 알람이 울립니다.</Typography>
          <Typography>5. 그 순간 차례인 사람이 당첨입니다.</Typography>
          <Typography>
            6. 알람은 볼륨 아이콘이나 중지 버튼으로 멈출 수 있습니다.
          </Typography>

          <Divider />

          <Typography variant="body2" color="text.secondary">
            ⚙ 고급설정에서 최소 대기 시간을 변경할 수 있습니다.
          </Typography>
        </Stack>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} variant="contained">
          닫기
        </Button>
      </DialogActions>
    </Dialog>
  );
}
